module.exports = __webpack_public_path__ + "assets/9b0cc9cdc11628c13b55de9276a2ed25.png";